import { useSearchParams } from "react-router-dom";
  
export default function Login() {
  const [params] = useSearchParams();
  const returnUrl = params.get("returnUrl") || "/";

  async function handleLoginClick() {
    const isLocalDev =
      window.location.hostname === "localhost" &&
      window.location.port === "5800";

    const bffBase = isLocalDev
      ? "https://localhost:5700"
      : "https://bff.dashboard.smallsoft.com.au";

    // 直接跳到 BFF 登录端点（由 BFF 触发 OAuth）
    window.location.href = `${bffBase}/auth/login?returnUrl=${encodeURIComponent(
      returnUrl
    )}`;

    // 后端会在 Response 内发 302，浏览器自动跳转
    //await API.post(`${bffBase}/auth/login`, { returnUrl });

  }

  return (
    <div style={{ marginTop: "3rem", textAlign: "center" }}>
      <h2>You are not logged in</h2>
      <p>Please sign in to continue.</p>

      <button
        onClick={handleLoginClick}
        style={{
          marginTop: "1rem",
          padding: "10px 20px",
          fontSize: "1rem",
          borderRadius: "6px",
          cursor: "pointer",
        }}
      >
        Sign In
      </button>
    </div>
  );
}